import Pathicon from "@pathwright/ux/src/components/pathicon/Pathicon"
import PropTypes from "prop-types"
import { AudioButtonUI } from "./ui"

export const PlayButton = ({ onTogglePlaying, playing }) => {
  return (
    <AudioButtonUI
      className="play-button"
      m="0 1rem"
      aria-label="Play Button"
      children={
        playing ? (
          <Pathicon icon="pause" size="32px" />
        ) : (
          <Pathicon icon="play" size="32px" />
        )
      }
      onClick={onTogglePlaying}
    />
  )
}

PlayButton.propTypes = {
  onTogglePlaying: PropTypes.func.isRequired,
  playing: PropTypes.bool
}

export default PlayButton
